import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
  CREATE_PATIENT_INF,
  CREATE_PATIENT_INF_ERROR,
  CREATE_PATIENT_INF_SUCCESS,
} from '../type';
import { initialState } from './initialize';

const createPatientReducer = handleActions(
  new Map([
    [
      CREATE_PATIENT_INF,
      state => {
        return update(state, {
          createPatientData: {
            loading: { $set: true },
            error: { $set: '' },
          },
        });
      },
    ],
    [
      CREATE_PATIENT_INF_ERROR,
      (state, action) => {
        return update(state, {
          createPatientData: {
            error: {
              $set: action.payload,
            },
            loading: { $set: false },
          },
        });
      },
    ],
    [
      CREATE_PATIENT_INF_SUCCESS,
      (state, action) => {
        return update(state, {
          createPatientData: {
            data: { $set: action.payload },
            loading: { $set: false },
          },
        });
      },
    ],
  ]),
  initialState,
);

export default createPatientReducer;
